import React, {useEffect, useState} from "react";
import {Bar, Pie} from "react-chartjs-2";
import {ArcElement, BarElement, CategoryScale, Chart as ChartJS, Legend, LinearScale, Tooltip} from "chart.js";
import {getWorkshopReport} from "../../../Api/Api";
import {useWorkshop} from "../../Common/WorkshopContext";
import JobTurnaroundChart from "./JobTurnaroundChart";
import RevenueTrendsChart from "./RevenueTrendsChart";
import {useNotification} from "../../Notification/NotificationContext";

ChartJS.register(ArcElement, Tooltip, Legend, CategoryScale, LinearScale, BarElement);

const ReportDashboard = () => {
    const [reportData, setReportData] = useState(null);
    const {workshopId} = useWorkshop();
    const { showNotification } = useNotification();

    useEffect(() => {
        getWorkshopReport(workshopId)
            .then((res) => {
                setReportData(res.data)
            })
            .catch((error) => showNotification(error.message || "Error fetching Report", "error"));
    }, []);

    if (!reportData) return <div className="text-center text-lg font-bold">Loading...</div>;

    return (
        <div className="mt-6">
                    <div className="p-6 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                        {/* Income Report */}
                        {reportData?.incomeData && (
                            <div className="bg-white p-4 rounded-lg shadow-md">
                                <h3 className="text-sm font-semibold mb-2 text-center">Income Report</h3>
                                <Bar
                                    data={{
                                        labels: reportData.incomeData.map((r) => r.month),
                                        datasets: [{
                                            label: "Income (INR)",
                                            data: reportData.incomeData.map((r) => r.totalIncome),
                                            backgroundColor: "#3b82f6",
                                        }],
                                    }}
                                    className="h-48"
                                />
                            </div>
                        )}

                        {/* Inventory Usage */}
                        {reportData?.inventoryUsage && (
                            <div className="bg-white p-4 rounded-lg shadow-md">
                                <h3 className="text-sm font-semibold mb-2 text-center">Inventory Usage</h3>
                                <Pie
                                    data={{
                                        labels: reportData?.inventoryUsage.map((item) => item.itemName),
                                        datasets: [{
                                            data: reportData?.inventoryUsage.map((item) => item.totalUsed),
                                            backgroundColor: ["#f87171", "#60a5fa", "#facc15", "#34d399"],
                                        }],
                                    }}
                                    className="h-48"
                                />
                            </div>
                        )}

                        {/* Job Turnaround Chart */}
                        <div className="bg-white p-4 rounded-lg shadow-md">
                            <h3 className="text-sm font-semibold mb-2 text-center">Job Turnaround Time</h3>
                            <JobTurnaroundChart workshopId={workshopId} />
                        </div>

                        {/* Revenue Trends Chart */}

                    </div>
                    <div className="bg-white p-4 rounded-lg shadow-md">
                        <h3 className="text-sm font-semibold mb-2 text-center">Revenue Trends</h3>
                        <RevenueTrendsChart workshopId={workshopId} />
                    </div>
        </div>

    );
};

export default ReportDashboard;
